export const initialState = {
	chartIds: []
};

export default { initialState };
